import React, { useEffect, useContext } from 'react';
import ReactGA from 'react-ga';
import {
    LoanApplicationInput,
    useUpdateLoanApplicationDataMutationMutation,
    useNotifyLoanApplicationCreatedByIdMutation,
    useTrackClientIpMutation,
    useGetLoanQuery
} from 'generated/graphql';
import { useNavigation } from 'hooks/index';
import { ProfileContext } from 'providers/profile.provider';
import CompanyInfoLayout from './company-info-layout';
import { useProduct } from 'providers/product.provider';
import { LoanApplicationContext } from 'containers/context/useGetLoanApplication';

const CompanyInfo: React.FC = () => {
    const { productDataFillOutFlow, setProductDataFillOutFlow } = useProduct();
    const [updateLoanApplicationDataMutation] = useUpdateLoanApplicationDataMutationMutation();
    const [notifyLoanApplicationCreatedById] = useNotifyLoanApplicationCreatedByIdMutation();
    const [trackClientIp] = useTrackClientIpMutation();
    const { nextScreen, previousScreen } = useNavigation();
    const { loanApplicationId } = useContext(LoanApplicationContext);
    const {
        steps: { responsibleInfo },
        profile,
    } = useContext(ProfileContext);

    const { data } = useGetLoanQuery({
        variables:{
            id:loanApplicationId
        },
        fetchPolicy:"cache-first"
    });

    useEffect(() => {
        if(!loanApplicationId) {
            return null;
        }
    },[loanApplicationId])

    useEffect(() => {
        ReactGA.event({
            category: 'Navegação Balcão',
            action: 'Exibição',
            label: 'Exibição /pedido/pre-aprovado/dados-da-empresa',
            nonInteraction: true,
        });
    }, []);

    useEffect(() => {
        if (data?.loanApplication) {
            if (productDataFillOutFlow.length === 0) {
                setProductDataFillOutFlow(data.loanApplication.product.dataFillOutFlow.map((dataFillOutFlow) => {
                    return {path: dataFillOutFlow.routerPath};
                }));
            }
        }
    }, [data.loanApplication]);

    const onSubmit = async (loanApplication: LoanApplicationInput) => {

        const companyDocument = data.loanApplication.borrower.companyDocument;

        const {
            monthlyRevenue,
            relationship,
            responsibleName,
            email,
            responsibleDocument,
            phone,
        } = loanApplication.borrower;

        await trackClientIp({ variables: { loanApplicationId: data.loanApplication.id } });

        await updateLoanApplicationDataMutation({variables: {
            loanApplicationId: data.loanApplication.id,
            companyInformation: { companyDocument, monthlyRevenue, relationship },
            responsibleInformation: { responsibleName, email, responsibleDocument, phone }
        }});

        notifyLoanApplicationCreatedById({variables: {loanApplicationId: data.loanApplication.id}});

        nextScreen();
    };

    const initializeForm = () => {
        const initialValue = {
            borrower: {
                responsibleName: '',
                email: '',
                phone: '',
                responsibleDocument: '',
                relationship: null,
                monthlyRevenue: 0,
            }
        };

        const borrower = data.loanApplication ? data.loanApplication.borrower : { }
        return {
            ...data.loanApplication,
            borrower: {
                ...borrower,
                ...initialValue.borrower
            },
            notification: {
                notifyBorrower: data.loanApplication.notification.notifyBorrower,
                notifyPartner: data.loanApplication.notification.notifyPartner,
            },
            agreeTerms: false,
            authorizeInformationAccess: false
        };
    }

    return (
        <CompanyInfoLayout
            initialValue={initializeForm()}
            stepInfo={responsibleInfo}
            screenProfile={profile}
            onBack={previousScreen}
            onSubmit={onSubmit}
        />
    );
};

export default CompanyInfo;
